var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#CF0A2C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300.9,131.4c-4.4-6.5-9.4-12.6-15-18.2c-2.4-2.4-4.9-4.7-7.5-6.9L333,51.7H174l-61.4,61.4h0c0,0-0.1,0.1-0.1,0.1 c-5.5,5.6-10.6,11.7-15,18.2c-4.4,6.6-8.2,13.6-11.3,20.8c-6.4,15.1-9.6,31.2-9.6,47.7c0,16.6,3.2,32.6,9.6,47.7 c3.1,7.3,6.9,14.3,11.3,20.8c4.4,6.5,9.4,12.6,15,18.2c2.4,2.4,4.9,4.7,7.5,6.9l-54.6,54.6h159l61.6-61.6h0 c5.5-5.5,10.5-11.6,14.9-18c4.4-6.6,8.2-13.6,11.3-20.8c6.4-15.1,9.6-31.2,9.6-47.7c0-16.6-3.2-32.6-9.6-47.7 C309.1,145,305.3,137.9,300.9,131.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.8,120.3c-2.4-2.4-4.9-4.7-7.4-6.8l-66.7,66.7c3.3,0.9,6.4,2.7,9,5.3l0,0c8.1,8.1,8.1,21.1,0,29.2 L89.9,338.3h14.5l116.4-116.4c12-12,12.1-31.5,0.1-43.6l7.2-7.2c16,16.1,15.9,42-0.1,58L118.9,338.3h14.5l101.9-101.9 c20-20,20.1-52.5,0.1-72.5l7.2-7.2c24,24.1,23.9,63-0.1,87l-94.7,94.7h14.5l87.4-87.4c28-28,28.1-73.4,0.1-101.5l7.2-7.2 c31.9,32.1,31.9,84-0.1,116l-80.2,80.2h14.5l72.9-72.9c36-36,36.1-94.4,0.1-130.5l7.3-7.3c40,40.1,39.9,105-0.1,145l-65.6,65.6 h14.5l58.4-58.4l0,0C322.8,235.8,322.8,164.4,278.8,120.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.7,279.7c2.4,2.4,4.9,4.7,7.4,6.8l66.7-66.7c-3.3-0.9-6.4-2.7-9-5.3l0,0c-8.1-8.1-8.1-21.1,0-29.2 L308.7,61.6h-14.5L177.7,178.1c-12,12-12.1,31.5-0.1,43.6l-7.2,7.2c-15.9-16.1-15.9-42,0.1-58L279.8,61.6h-14.5L163.2,163.6 c-20,20-20.1,52.5-0.1,72.5l-7.2,7.2c-24-24.1-23.9-63,0.1-87l94.8-94.8h-14.5l-87.6,87.6c-28,28-28.1,73.4-0.1,101.5l-7.2,7.2 c-31.9-32.1-31.9-84,0.1-116l80.3-80.3h-14.5l-73.1,73.1c-36,36-36.1,94.4-0.1,130.5l-7.3,7.3c-40-40.1-39.9-105,0.1-145l65.8-65.8 h-14.5l-58.6,58.6l0,0C75.7,164.2,75.7,235.7,119.7,279.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPor);
export default __webpack_public_path__ + "static/media/POR.4b262d67690a4b935188ad67e65d1ef2.svg";
export { ForwardRef as ReactComponent };